import { render } from "./IDemoPicker.vue?vue&type=template&id=fe38f46c"
import script from "./IDemoPicker.vue?vue&type=script&lang=js"
export * from "./IDemoPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__